module.exports = __webpack_public_path__ + "media/images/countryrect/zz-147fa1af59ae94fd1cefc7ccae35ecae.svg";